import React, { ReactElement } from 'react'
import SectionContainer from '../SectionContainer'
import OtherIcon from 'images/integrations/other.svg'
import ItemContainer from '../ItemContainer'
import Tailscale from 'images/integrations/other/tailscale.svg'

export default function OtherSection(): ReactElement {
  return (
    <SectionContainer isOrangeBlur sectionIcon={OtherIcon} title="Other">
      <ItemContainer icon={Tailscale} title="Tailscale" learnMorePath="tailscale-integration" />
    </SectionContainer>
  )
}
